<template>
  <router-view></router-view>
</template>

<script>
export default {
}
</script>
<style>
.card.no-padding .card-body {
  padding: 0;
}
.card.no-padding .card-title {
  padding: 1.5rem 1.5rem 0 1.5rem;
}
.card.no-padding .el-table__expanded-cell {
  padding: 0 1rem;
  background: #EFEFEF;
}
.card.no-padding .el-table__expanded-cell:hover {
    background-color: #EFEFEF !important;
}
.card.no-padding .el-table__expanded-cell .row {
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: .9em;
}

.el-table__expand-icon>.el-icon {
  margin-top: -10px !important;
  font-size: 1.5em;
  font-weight: bold;
}
</style>
